import React from 'react';
import { Layout, CreateOther as Team } from '@components/team';

const CreateOther = () => {
    return <Team />;
};

CreateOther.Layout = Layout;
export default CreateOther;
